import { Component, Input, Output, EventEmitter  } from '@angular/core';
import { OkechargeChargepoint } from '../../../api/chargepoints-api.service';
import { CommonModule } from '@angular/common';
import { ChargepointCardComponent } from '../../../components/chargepoints/chargepoint-card/chargepoint-card.component';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TransactionsListComponent } from '../../../components/transactions/transactions-list/transactions-list.component';
import { JsonViewerService } from '../../../components/common/json-viewer-dialog/json-viewer.service';
import { TransactionApiService } from '../../../api/transactions-api.service';
import { TransactionMonitorDialogService } from '../../../components/transactions/transaction-monitor-dialog/transaction-monitor-dialog.service';
import { MatDialog } from '@angular/material/dialog';
import { ChargepointTracesDialogComponent } from '../../../components/chargepoint-traces/chargepoint-traces-dialog/chargepoint-traces-dialog.component';
import { ReplaySubject, Subject } from 'rxjs';
import { ChargepointsOkechargeApiService } from '../../../api/chargepoints-okecharge-api.service';

@Component({
  selector: 'app-okecharge-chargepoint-page',
  templateUrl: './okecharge-chargepoint-page.component.html',
  styleUrls: ['./okecharge-chargepoint-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ChargepointCardComponent,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatTooltipModule,
    TransactionsListComponent,
  ]
})
export class OkechargeChargepointPageComponent {

  @Input()
  chargepoint!: OkechargeChargepoint;

  @Output()
  refresh = new EventEmitter<void>();

  public refreshConfigurationTrigger$: Subject<void> = new ReplaySubject<void>(1);

  constructor(
    private chargepointsOkechargeApiService: ChargepointsOkechargeApiService,
    private transactionApiService: TransactionApiService,
    private transactionMonitorDialogService: TransactionMonitorDialogService,
    private snackBar: MatSnackBar,
    public jsonViewerService: JsonViewerService,
    private dialog: MatDialog
  ) {
    this.refreshConfigurationTrigger$.next();
  }

  public startTransaction() {
    if (this.chargepoint) {
      this.transactionApiService.startTransaction({
        chargepointId: this.chargepoint.id,
        chipId: this.chargepoint.chipId,
        type: this.chargepoint.type
      }).subscribe((transaction) => {
        this.snackBar.open('Transaction started', 'Close', { duration: 3000 });
        this.transactionMonitorDialogService.open(transaction);
        this.refresh.emit();
      });
    }
  }

  public requestStatus() {
    this.chargepointsOkechargeApiService.requestStatus(this.chargepoint.id).subscribe(() => {
      this.snackBar.open('Status requested', 'Close', { duration: 3000 });
    });
  }

  public showLogsDialog() {
    this.dialog.open(ChargepointTracesDialogComponent, {
      data: { chargepoint: this.chargepoint },
      width: '850px',
      maxWidth: '850px'
    });
  }
}
